module.exports = __webpack_public_path__ + "static/pinkfloral5-134b9a4d7bb151ef5f5702428bb114ce.png";